export const NodeTypes = [
    {
        name: "Sensor",
        displayName: "Sensor",
    },
    {
        name: "Number",
        displayName: "Number",
    },
    {
        name: "Generator",
        displayName: "Waves",
    },
    // Timer block hidden from the palette. Kept in code (rete-manager registration, node class) so
    // existing programs that already contain a Timer node still load.
    // {
    //   name: "Timer",
    //   displayName: "Timer (on/off)"
    // },
    {
        name: "Math",
        displayName: "Math",
    },
    {
        name: "Logic",
        displayName: "Compare",
    },
    {
        name: "Transform",
        displayName: "Transform",
    },
    {
        name: "Control",
        displayName: "Hold",
    },
    {
        name: "Demo Output",
        displayName: "Demo Device",
    },
    {
        name: "Live Output",
        displayName: "Live Device",
    }
];
const displayNameByType = new Map(NodeTypes.map(nt => [nt.name, nt.displayName]));
/**
 * The word a student sees for a block of the given internal type. The palette has been renamed
 * since these internal type strings were chosen (e.g. "Generator" displays as "Waves"), so anything
 * that names a block to a person — or to an AI that will name it to a person — has to go through
 * here. Unmapped types (the hidden Timer, and anything a future program carries that the palette no
 * longer offers) fall back to the internal string, which is better than naming nothing at all.
 */
export function displayNameForType(type) {
    var _a;
    return (_a = displayNameByType.get(type)) !== null && _a !== void 0 ? _a : type;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0YWZsb3ctbm9kZS10eXBlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NoYXJlZC9kYXRhZmxvdy1ub2RlLXR5cGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVdBLE1BQU0sQ0FBQyxNQUFNLFNBQVMsR0FBZTtJQUNuQztRQUNFLElBQUksRUFBRSxRQUFRO1FBQ2QsV0FBVyxFQUFFLFFBQVE7S0FDdEI7SUFDRDtRQUNFLElBQUksRUFBRSxRQUFRO1FBQ2QsV0FBVyxFQUFFLFFBQVE7S0FDdEI7SUFDRDtRQUNFLElBQUksRUFBRSxXQUFXO1FBQ2pCLFdBQVcsRUFBRSxPQUFPO0tBQ3JCO0lBQ0QsK0ZBQStGO0lBQy9GLGtFQUFrRTtJQUNsRSxJQUFJO0lBQ0osbUJBQW1CO0lBQ25CLGtDQUFrQztJQUNsQyxLQUFLO0lBQ0w7UUFDRSxJQUFJLEVBQUUsTUFBTTtRQUNaLFdBQVcsRUFBRSxNQUFNO0tBQ3BCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsT0FBTztRQUNiLFdBQVcsRUFBRSxTQUFTO0tBQ3ZCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsV0FBVztRQUNqQixXQUFXLEVBQUUsV0FBVztLQUN6QjtJQUNEO1FBQ0UsSUFBSSxFQUFFLFNBQVM7UUFDZixXQUFXLEVBQUUsTUFBTTtLQUNwQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLGFBQWE7UUFDbkIsV0FBVyxFQUFFLGFBQWE7S0FDM0I7SUFDRDtRQUNFLElBQUksRUFBRSxhQUFhO1FBQ25CLFdBQVcsRUFBRSxhQUFhO0tBQzNCO0NBQ0YsQ0FBQztBQUVGLE1BQU0saUJBQWlCLEdBQUcsSUFBSSxHQUFHLENBQUMsU0FBUyxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsRUFBRSxDQUFDLENBQUMsRUFBRSxDQUFDLElBQUksRUFBRSxFQUFFLENBQUMsV0FBVyxDQUFDLENBQUMsQ0FBQyxDQUFDO0FBRWxGOzs7Ozs7R0FNRztBQUNILE1BQU0sVUFBVSxrQkFBa0IsQ0FBQyxJQUFZOztJQUM3QyxPQUFPLE1BQUEsaUJBQWlCLENBQUMsR0FBRyxDQUFDLElBQUksQ0FBQyxtQ0FBSSxJQUFJLENBQUM7QUFDN0MsQ0FBQyJ9